<template>
	<div
		class="d-flex align-items-center justify-content-center h-100 bg-light"
	>
		<div class="col-md-4 col-lg-3">
			<div class="card shadow-sm border-0">
				<div class="card-body p-4">
					<div class="text-center mb-4">
						<h4 class="text-uppercase fw-bold">
							{{ $t("register-title") }}
						</h4>
						<p class="text-muted">{{ $t("register-subtitle") }}</p>
					</div>

					<form @submit.prevent="handleRegister">
						<!-- Логин -->
						<div class="mb-3">
							<label class="form-label" for="inputLogin">{{ $t("label-login") }}</label>
							<input
								v-model="form.login"
								@input="validateLoginInput"
								id="inputLogin"
								ref="loginInput"
								type="text"
								class="form-control"
								:placeholder="$t('placeholder-login')"
								required
								:disabled="loading"
							/>
						</div>

						<!-- Пароль -->
						<div class="mb-3">
							<label class="form-label" for="inputPassword">{{ $t("label-password") }}</label>
							<div class="input-group">
								<input
									v-model="form.password"
									id="inputPassword"
									:type="passwordShow ? 'text' : 'password'"
									class="form-control"
									:placeholder="$t('placeholder-password')"
									required
									:disabled="loading"
								/>
								<button
									class="btn btn-outline-secondary px-2"
									type="button"
									@click="passwordShow = !passwordShow"
								>
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path v-if="passwordShow" d="M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z" />
										<path v-else d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z" />
									</svg>
								</button>
							</div>
						</div>

						<!-- Подтверждение пароля -->
						<div class="mb-3">
							<label class="form-label" for="inputConfirm">{{ $t("label-confirm-password") }}</label>
							<div class="input-group">
								<input
									v-model="form.confirmPassword"
									id="inputConfirm"
									:type="passwordShow ? 'text' : 'password'"
									class="form-control"
									:placeholder="$t('placeholder-confirm-password')"
									required
									:disabled="loading"
								/>
								<button
									class="btn btn-outline-secondary px-2"
									type="button"
									@click="passwordShow = !passwordShow"
								>
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path v-if="passwordShow" d="M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z" />
										<path v-else d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z" />
									</svg>
								</button>
							</div>
						</div>

						<div class="d-grid mt-4">
							<button type="submit" class="btn btn-primary" :disabled="loading">
								<span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
								{{ $t("btn-register") }}
							</button>
						</div>

						<div class="text-center mt-3">
							<router-link to="/login" class="text-muted text-decoration-none small">
								{{ $t("link-back-to-login") }}
							</router-link>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped></style>

<script>
import lib from "@/lib";
import { useMeta } from "vue-meta";

export default {
	mixins: lib.mixins,
	setup() {
		useMeta({ title: "Регистрация | SKV" });
	},
	data: () => ({
		form: {
			login: "",
			password: "",
			confirmPassword: "",
		},
		passwordShow: false,
		loading: false,
	}),
	methods: {
		validateLoginInput() {
			// Оставляем только A-Z, a-z, 0-9 и _
			// Все остальное заменяем на пустую строку
			this.form.login = this.form.login.replace(/[^a-zA-Z0-9_]/g, '');
		},
		focusLogin() {
			// Используем nextTick, чтобы Vue успел отрендерить элементы
			this.$nextTick(() => {
				this.$refs.loginInput?.focus();
			});
		},

		async handleRegister() {
			// Валидация совпадения паролей
			if (this.form.password !== this.form.confirmPassword) {
				return this.$toast.error(this.$t("error-password-mismatch"));
			}

			this.loading = true;
			try {
				// Предполагаем, что метод в authModel называется doRegister
				const result = await this.authModel.doRegister(
					this.form.login,
					this.form.password,
				);

				if (result.success) {
					this.$toast.success(this.$t("success-register"));
					
					// После регистрации обычно либо сразу логиним, либо отправляем на логин
					this.$router.push("/login");
				} else {
					this.$toast.error(result.message || this.$t("error-register-failed"));
					this.focusLogin();
				}
			} catch (e) {
				this.$toast.error(this.$t("error-server"));
				this.focusLogin();
			} finally {
				this.loading = false;
			}
		},
	},
	mounted() {
		this.focusLogin();
	},
};
</script>
